export const CHAT_GLOBAL_SETTINGS_UPDATED_EVENT = "apit:chat-global-settings-updated";

export function isSidebarLastMessageEnabled(settings = {}) {
	return settings?.showSidebarLastMessage !== false;
}

export function isSidebarCompactModeEnabled(settings = {}) {
	return settings?.sidebarCompactMode === true;
}
